module.exports = __webpack_public_path__ + "fonts/NetflixSansBold.ac2373b8.ttf";